import { sanitizeInternalRedirectPath } from 'utils/sanitizeInternalRedirectPath';

export const POST_AUTH_REDIRECT_KEY = 'sttok_post_auth_redirect';

const AUTH_ENTRY_PATHS = new Set([
  '/login',
  '/pwc-login',
  '/pld-login',
  '/callback',
  '/demo',
]);

/** Legal / cookie pages (AXA) — do not treat as deep-link targets */
const AXA_LEGAL_SUFFIX = /\/(privacidad|cookies|aviso-legal)$/;

export function isAuthEntryPath(pathname: string): boolean {
  if (!pathname || pathname === '/') {
    return true;
  }
  if (AUTH_ENTRY_PATHS.has(pathname)) {
    return true;
  }
  if (AXA_LEGAL_SUFFIX.test(pathname)) {
    return true;
  }
  return false;
}

export function persistPostAuthRedirectFromRaw(raw: string): void {
  const sanitized = sanitizeInternalRedirectPath(raw);
  if (!sanitized) {
    return;
  }
  sessionStorage.setItem(POST_AUTH_REDIRECT_KEY, sanitized);
}

export function persistPostAuthRedirectFromLocation(
  pathname: string,
  search: string
): void {
  if (isAuthEntryPath(pathname)) {
    return;
  }
  const combined = `${pathname}${search || ''}`;
  persistPostAuthRedirectFromRaw(combined);
}

/** Path to pass to Auth0 loginWithRedirect appState.returnTo */
export function peekSanitizedPostAuthRedirect(): string | null {
  const raw = sessionStorage.getItem(POST_AUTH_REDIRECT_KEY);
  return sanitizeInternalRedirectPath(raw);
}

export function getReturnToForAuth0Login(): string {
  return peekSanitizedPostAuthRedirect() || '/';
}

export function clearPostAuthRedirect(): void {
  sessionStorage.removeItem(POST_AUTH_REDIRECT_KEY);
}
